import { SourceDefinitionCategory } from './types';

type ApiSourceDefinition = Record<string, unknown> & {
  id: string;
  name: string;
  displayName: string;
  uiConfig?: unknown;
  category: SourceDefinitionCategory;
};

export class SourceDefinition {
  constructor(readonly sourceDefinition: ApiSourceDefinition) {}

  public get id() {
    return this.sourceDefinition.id;
  }

  public get name() {
    return this.sourceDefinition.name;
  }

  public get displayName() {
    return this.sourceDefinition.displayName;
  }

  public get category() {
    return this.sourceDefinition.category;
  }

  public get createFlow() {
    return (
      !Array.isArray(this.sourceDefinition.uiConfig) &&
      (this.sourceDefinition.uiConfig as Record<string, unknown>)?.createFlow
    );
  }
}
